<template>
  <div class="style-wrapper style-wrapper-2">
    <div :class="['list_box', 'listBoxWrapper','list-box-'+listArr.module_style]" ref="rowEL">
      <swiper
        ref="mySwiper"
        v-if="swiperIsRender"
        :key="swiperKey" 
        class="swiper-container my-swiper-box"
        :options="swiperOption"
      >
        <swiper-slide v-for="(item,i) in filledImgs"
                      :key="i"
                      :style="{width:(100/infor.col_num[infor.col_num.radio_val].value) + '%'}">
          <one_picture
            v-if="item !=='mock'"
            :item="item"
            :i="i"
            :key="i"
            :pc_infor="pc_infor"
            :infor="infor"
            :imgs="imgs"
            :module="module"
          ></one_picture>
          <div v-else>is mock</div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="bt-group">
      <div class="btn-pagination btn-prev" @click="swiperPrev">
        <i class="fa fa-angle-double-up"></i>
      </div>
      <div class="btn-pagination btn-next" @click="swiperNext">
        <i class="fa fa-angle-double-down"></i>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import one_picture from "./one_picture";

export default {
  name: "basic_picture_text_swiper_group_style_2.vue",
  components: {
    one_picture,
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    pc_infor: {
      type: Object,
      default: null
    },
    infor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "ordinary"
    },
    imgs: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      swiperIsRender: true,
      swiperKey: Math.random().toString(36).substr(2),
    }
  },
  computed: {
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor;
    },
    filledImgs() {
      // 修复每行3个只有4张图片时显示异常的问题
      let list = this.imgs
      if (!this.isPC) {
        return list
      }
      let infor = this.pc_infor
      let num = parseInt(infor.col_num[infor.col_num.radio_val].value)
      let length = list.length
      if(length % num != 0){
        let mockList = new Array(num - length % num).fill('mock')
        list = list.concat(mockList)
      }
      return list
    },
    listArr() {
      return this.module.data.listArr
    },
    backgroundStyle() {
      return this.$utils.getBackgroundStyle(this.pc_infor)
    },
    paddingStyle() {
      let info = this.pc_infor.padding
      if (info.radio_val !== 'default') {
        let paddingTop = info.custom.paddingTop
        let paddingLeft = info.custom.paddingLeft
        // if (!String(paddingTop).endsWith('%') && !String(paddingTop).endsWith('px')) {
        //   paddingTop = paddingTop + '%'
        // }
        // 模块样式2的paddingtop特殊处理
        paddingTop = '10%'

        if (!String(paddingLeft).endsWith('%') && !String(paddingLeft).endsWith('px')) {
          paddingLeft = paddingLeft + '%'
        }

        return {
          padding: paddingTop + ' ' + paddingLeft
        }
      } else {
        return {
          padding: info.default.paddingTop + ' ' + info.default.paddingLeft
        }
      }
    },
    swiperOption() {
      if (this.$store.state.app.view_pattern === 'pc') {
        return this.pcSwiperOption
      } else {
        return this.mobileSwiperOption
      }
    },
    pcSwiperOption() {
      const infor = this.infor;
      const num = parseInt(infor.col_num[infor.col_num.radio_val].value);
      const slidesPerGroup = parseInt(infor.col_num[infor.col_num.radio_val].value)  // 每次翻页个数     // parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        direction: "vertical",
        slidesPerView: 2,
        slidesPerColumn: parseInt(infor.col_num[infor.col_num.radio_val].value), /// parseInt(infor.col_num[infor.col_num.radio_val].value),  /// 2, // 每行个数
        // slidesPerGroup: num ,//* 2, // 每次点上一页下一页 翻多少
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        // slidesPerColumnFill: 'row',
      }
      const autoplay = this.templet.autoplay_obj(
        infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    mobileSwiperOption() {
      const num = parseInt(this.infor.col_num[this.infor.col_num.radio_val].value);
      return {
        loop: false,
        direction: 'horizontal',
        slidesPerView: num + 0.3,
        slidesPerColumn: 1,
        freeMode: true
      }
    }
  },
  watch: {
    'infor.col_num': {
      handler() {
        this.reRenderSwiper()
      },
      deep: true
    },
    'infor.banner_set': {
      handler() {
        this.reRenderSwiper()
      },
      deep: true
    },
    '$store.state.app.view_pattern'() {
      setTimeout(() => {
        this.reRenderSwiper()
      }, 500)
    }
  },
  methods: {
    swiperStart() {
      this.$refs.mySwiper.swiper.autoplay.start();
    },
    swiperStop() {
      this.$refs.mySwiper.swiper.autoplay.stop();
    },
    swiperPrev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiperNext() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    reRenderSwiper() {
      this.swiperKey = Math.random().toString(36).substr(2);
    }
  }
}
</script>

<style scoped lang="scss">
.basic_picture_text_swiper {
  .list_frame {
    width: 100%;

    .listBoxWrapper {
      width: 100%;
    }

    .my-swiper-box {
      width: 100%;
    }

    .swiper-container {
      flex: 1;
      //width: calc(100% - 50px);
      height: 500px;
      display: flex;
      flex-flow: wrap;
      font-size: 0;
      position: relative;
      align-items: center;
      width: 100%;
    }


  }

  .swiper-slide {
    padding: calc(0.3% + 8px);
  }

  .style-wrapper {
    display: flex;
    align-items: center;
  }

  /deep/ .icon-combination-summary {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .btn-pagination {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    border-radius: 40px;
    position: relative;
    background: rgba(0, 0, 0, 0.2);

    &:before {
      content: "";
      position: absolute;
      display: block;
      width: 10px;
      height: 18px;
      background: url(/static/image/backimg1.png) -23px -268px;
      top: 50%;
      left: 50%;
      transform: translate(-50%) translateY(-50%);
      //margin-top: -9px;
      //margin-left: -5px;
    }

    &.btn-next:before {
      background-position-x: -53px;
      left: 54%;
    }

    &.btn-prev {
      transform: rotate(90deg);
    }

    &.btn-next {
      transform: rotate(90deg);
    }

  }

  .btn-pagination i {
    font-size: 35px;
    color: #000;
    vertical-align: middle;
    display: none;
    opacity: 0;
  }

  .btn-prev {
    margin-bottom: 250px;
  }

  .btn-next {
    margin-top: 250px;
  }
}
</style>
<style lang="scss">
.basic_picture_text_swiper {
  .style-wrapper-2 {
    .swiper-wrapper {
      margin: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_picture_text_swiper/components/group_style_2.vue